module.exports = __webpack_public_path__ + "static/media/phone-call2.0fda328d.svg";